import bbox from "@turf/bbox";
import axios from "axios";
import DefaultImg from "../../../assets/images/default.png";
import { LocalStorageKey } from "../../../constants/localStorageKeys";
import { ESttausCode } from "../../../enums";
import { showError, showSuccess } from "../../../helpers/toast";
import { addImgIntoCartAsync, delImgIntoCartAsync, setArrIdImage } from "../../../store/reducers/cartSlice";
import { setLoadingProvider } from "../../../store/reducers/searchSlice";
import { MapAdapter } from "../MapAdapter/core/MapAdapter";
import { GEOJSON_FEATURE_COLOR_HOVER } from "../MapAdapter/layers/consts";
import { addLayer, removeLayer } from "../MapAdapter/store/slices/layerSlice";
import dayjs from "dayjs";

export function getThumbnail(links: any, baseUrl: string)
{

   // {
   //    "full_resolution_thumbnail": {
   //       "href": "s3://assets.satellitevu.com/high-res/20231208_161101_HS1_thumbnail.png",
   //          "roles": [
   //             "thumbnail"
   //          ],
   //             "type": "image/png"
   //    },
   //    "thumbnail": {
   //       "href": "https://assets.satellitevu.com/20231208_161101_HS1_degraded_thumbnail.png",
   //          "roles": [
   //             "thumbnail"
   //          ],
   //             "type": "image/png"
   //    }
   // }
   if (!links) return DefaultImg;

   // const t = links.find((l) => l.roles?.includes('thumbnail'));
   // console.log(t);

   // if (t?.sub_path && t?.sub_path !== "")
   // {
   //    return baseUrl + "/vmrs" + t.sub_path;
   // } else if (t?.href && t?.href !== "")
   // {
   //    return t.href;
   // } else
   // {
   //    return DefaultImg;
   // }

   if (links?.thumbnail)
   {
      return links?.thumbnail?.href
   }


}

export const flyToGeometry = (geometry: any, mapInstance: any) =>
{
   console.log(mapInstance, "mapRef");
   if (!geometry || !mapInstance) return;

   const bounds = bbox({
      type: "Feature",
      geometry,
      properties: {},
   });

   mapInstance.fitBounds(bounds, {
      padding: 40,
      duration: 1000,
   });
};

export const flyToGeometries = (geometries: any[], mapInstance: any) =>
{
   const valid = geometries.filter(Boolean);
   if (!valid.length || !mapInstance) return;

   const bounds = bbox({
      type: "FeatureCollection",
      features: valid.map((geometry) => ({ type: "Feature", geometry, properties: {} })),
   });

   mapInstance.fitBounds(bounds, {
      padding: 60,
      duration: 1000,
   });
};

export const getBBoxFromGeometry = (geometry: any): [number, number, number, number] =>
{
   if (!geometry || !geometry.coordinates) return [0, 0, 0, 0];

   const coords: number[][] = [];

   const extract = (arr: any) =>
   {
      if (typeof arr[0] === "number")
      {
         coords.push(arr);
      } else
      {
         arr.forEach(extract);
      }
   };

   extract(geometry.coordinates);

   let minX = Infinity;
   let minY = Infinity;
   let maxX = -Infinity;
   let maxY = -Infinity;

   coords.forEach(([x, y]) =>
   {
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
   });

   return [minX, minY, maxX, maxY];
};

export const getImage = async (thumbnailUrl: string) =>
{
   // if thumbnailUrl is not 401 or CORS is no need.
   const response = await axios.get(thumbnailUrl, { responseType: "blob" });



   if (response?.status === 200)
   {
      let contentType =
         response.headers && response.headers["content-type"]
            ? response.headers["content-type"]
            : "image/jpg";
      let blob = new Blob([response.data], {
         type: contentType,
      });

      if (blob.size != 0)
      {

         //@ts-ignore
         if (!window.navigator?.msSaveOrOpenBlob)
         {

            // BLOB NAVIGATOR
            return window.URL.createObjectURL(blob);
         } else
         {

            // BLOB FOR EXPLORER 11
            //@ts-ignore
            return window.navigator.msSaveOrOpenBlob(blob, contentType);
         }
      }
   }
   return thumbnailUrl;
};

export const getImageUrlAndCoordinates = async (item: any) =>
{
   const staticConfigs = JSON.parse(
      localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
   );
   const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
   const bboxFeature = getBBoxFromGeometry(item.geometry);

   const coordinates = [
      [bboxFeature[0], bboxFeature[3]],
      [bboxFeature[2], bboxFeature[3]],
      [bboxFeature[2], bboxFeature[1]],
      [bboxFeature[0], bboxFeature[1]],
   ];

   // let t = item?.links?.find((l: any) => l?.rel === "thumbnail");
   // const thumbnailUrl =
   //    t?.sub_path && t?.sub_path !== ""
   //       ? baseUrl + "/vmrs" + t?.sub_path
   //       : t?.href && t?.href !== ""
   //          ? t?.href
   //          : undefined;

   // if (!thumbnailUrl) return;

   const thumbnailUrl = getThumbnail(item?.assets, baseUrl);

   console.log(thumbnailUrl, 'thumbnailUrl');

   const imageUrl = await getImage(thumbnailUrl);



   return {
      imageUrl,
      coordinates,
   };
};



export interface ImageItem
{
   id: string;
   geometry: any;
   properties: Record<string, any>;
}

export interface MapLayerBase
{
   id: string;
   name: string;
   visible: boolean;
   visibility: boolean;
   opacity: number;
   zIndex: number;
}

export const showFootprint = (
   item: ImageItem,
   dispatch: any,
   mapInstance: any,
   skipFly = false,
) =>
{
   const base: MapLayerBase = {
      id: `footerprint-${item.id}`,
      name: item.id,
      visible: true,
      visibility: true,
      opacity: 1,
      zIndex: 100,
   };

   dispatch(
      addLayer({
         ...base,
         type: "geojson",
         geojsonData: {
            type: "FeatureCollection",
            features: [
               {
                  type: "Feature",
                  id: item.id,
                  geometry: item.geometry,
                  properties: item.properties ?? {},
               },
            ],
         },
      })
   );

   if (!skipFly) flyToGeometry(item.geometry, mapInstance);
};

export const removeFootprint = (item: ImageItem, dispatch: any) =>
{
   dispatch(removeLayer(`footerprint-${item.id}`));
};

export const panToImage = (
   item: ImageItem,
   mapInstance: any
) =>
{
   flyToGeometry(item.geometry, mapInstance);
};


export const addImagesToCart = async (
   ids: string[],
   dispatch: any,
   providerCode: string,
   idsImageInCart: string[],
   t: any
) =>
{
   dispatch(setLoadingProvider({ code: providerCode, value: true }));

   try
   {
      const res = await dispatch(
         // @ts-ignore
         addImgIntoCartAsync({
            stac_item_ids: ids,
         })
      ).unwrap();

      if (
         res?.status === ESttausCode.OK ||
         res?.status === ESttausCode.CREATED
      )
      {
         showSuccess(t("Add image to cart successfully"));

         const result = [...idsImageInCart, ...ids];

         dispatch(setArrIdImage(result));
      } else
      {
         showError(
            t(res?.response?.data?.message) ??
            t("Add image to cart failed")
         );
      }
   } catch
   {
      showError(t("Add image to cart failed"));
   } finally
   {
      dispatch(setLoadingProvider({ code: providerCode, value: false }));
   }


};


export const removeImagesFromCart = async (
   ids: string[],
   dispatch: any,
   providerCode: string,
   idsImageInCart: string[],
   t: any
) =>
{
   dispatch(setLoadingProvider({ code: providerCode, value: true }));

   try
   {

      const res = await dispatch(
         // @ts-ignore
         delImgIntoCartAsync({
            cart_item_ids: ids,
         })
      ).unwrap();

      if (res?.status === ESttausCode.OK)
      {
         showSuccess(t("Delete image from cart successfully"));

         const result = idsImageInCart.filter(
            (id) => !ids.includes(id)
         );

         dispatch(setArrIdImage(result));
      } else
      {
         showError(t("Delete image from cart failed"));
      }
   } catch
   {
      showError(t("Delete image from cart failed"));
   }

   dispatch(setLoadingProvider({ code: providerCode, value: false }));
};


export const showImageOnMap = async (
   item: ImageItem,
   dispatch: any,
   providerCode: string,
   mapInstance: any,
   skipFly = false,
) =>
{
   dispatch(setLoadingProvider({ code: providerCode, value: true }));

   const { imageUrl, coordinates } =
      (await getImageUrlAndCoordinates(item)) || {};

   const base: MapLayerBase = {
      id: `image-${item.id}`,
      name: item.id,
      visible: true,
      visibility: true,
      opacity: 1,
      zIndex: 100,
   };

   dispatch(
      addLayer({
         ...base,
         type: "image",
         url: imageUrl,
         imageParams: {
            coordinates,
            urlType: imageUrl,
         },
      })
   );

   if (!skipFly) flyToGeometry(item.geometry, mapInstance);

   dispatch(setLoadingProvider({ code: providerCode, value: false }));
};

export const removeImageFromMap = (
   item: ImageItem,
   dispatch: any
) =>
{
   dispatch(removeLayer(`image-${item.id}`));
};

export const mouseMoveItem = (
   item: ImageItem,
   engine?: MapAdapter | null
) =>
{
   if (!engine?.updateGeoJSONSource) return;

   const featureCollection: GeoJSON.FeatureCollection = {
      type: "FeatureCollection",
      features: [
         {
            type: "Feature",
            id: item.id,
            geometry: item.geometry,
            properties: {
               ...item.properties,
               color: GEOJSON_FEATURE_COLOR_HOVER,
            },
         },
      ],
   };

   engine.updateGeoJSONSource(
      `footerprint-${item.id}`,
      featureCollection
   );
};

export const mouseLeaveItem = (
   item: ImageItem,
   engine?: MapAdapter | null
) =>
{
   if (!engine?.updateGeoJSONSource) return;

   const featureCollection: GeoJSON.FeatureCollection = {
      type: "FeatureCollection",
      features: [
         {
            type: "Feature",
            id: item.id,
            geometry: item.geometry,
            properties: item.properties,
         },
      ],
   };

   engine.updateGeoJSONSource(
      `footerprint-${item.id}`,
      featureCollection
   );
};

export const checkTypeImageIncludeProvider = (imageType: any) =>
{
   if (!imageType) return [];

   return imageType?.providers ?? [];
};

const isDateField = (key: string) =>
{
   const k = key.toLowerCase();
   return (
      k.includes("date") ||
      k.includes("time") ||
      k.includes("start") ||
      k.includes("end")
   );
};

const isTimestamp = (value: any) =>
{
   if (typeof value === "number") return true;

   if (typeof value === "string" && /^\d+$/.test(value))
   {
      return true;
   }

   return false;
};

export const formatValue = (value: any, key?: string) =>
{
   if (value === null || value === undefined || value === "") return "-";

   // 👉 HANDLE TIMESTAMP
   if (key && isDateField(key) && isTimestamp(value))
   {
      const d = dayjs(Number(value));
      if (d.isValid()) return d.format("DD/MM/YYYY");
   }

   // 👉 RANGE DATE (string dạng a/b)
   if (typeof value === "string" && value.includes("/"))
   {
      const [start, end] = value.split("/");

      const startDate = dayjs(start);
      const endDate = dayjs(end);

      if (startDate.isValid() && endDate.isValid())
      {
         return `${startDate.format("DD/MM/YYYY")} - ${endDate.format("DD/MM/YYYY")}`;
      }
   }

   // 👉 ISO DATE
   if (typeof value === "string" && value.includes("T"))
   {
      const d = dayjs(value);
      if (d.isValid()) return d.format("DD/MM/YYYY");
   }

   return String(value);
};
export const formatKey = (key: string) =>
{
   return key
      .replace(/_/g, " ")                // bỏ _
      .replace(/\b\w/g, (char) => char.toUpperCase()); // viết hoa chữ cái đầu
};